import { InAppContentDefinition } from 'modules/graphql/types';

import { useEditableFieldsContext } from '../../../context/EditableFieldsContext';
import { SETTINGS_DISPLAY_CONTENT } from '../../constants';
import { FontFormField } from './shared/FontFormField';

export const RokuBodyFont = () => {
  const { liveTemplate } = useEditableFieldsContext();
  const { ottPayload } = (liveTemplate?.mediumData || {}) as InAppContentDefinition;

  return (
    <FontFormField
      field="dialogBodyFont"
      value={ottPayload?.dialogBodyFont}
      condition={!!ottPayload?.dialogText}
      label={SETTINGS_DISPLAY_CONTENT.roku.fonts.bodyLabel}
      data-test="form-field-roku-body-font"
    />
  );
};
